/*
 * 把后端数据里写死域名的绝对URL改写成跟随当前 origin。
 *
 * 背景：库里存的头像/图片/文件 URL 都是带生产域名的绝对地址，域名被 DNS 投毒/SNI
 * 阻断的地区加载不了(解析到127.0.0.1)。改写成**相对路径**(剥掉域名前缀)后，
 * 渲染时自动跟随当前 origin：页面从域名打开走域名、从纯IP应急通道打开就走IP
 * (nginx 的 /oss-files/ 代理两条通道都通)。相对路径缓存进 IndexedDB 也安全，
 * 域名/纯IP 两个入口打开同一份缓存都可用。
 *
 * 注意：message.content 是 JSON **字符串**，URL 藏在字符串内部，普通递归走不进去，
 * 这里对可解析为对象/数组的字符串额外做"解析-改写-回串"。
 */
// 商用化:不再硬编码具体域名,运行时取当前页面 origin(客户部署任意域名均可生效)
const PROD_DOMAINS = (typeof window !== 'undefined' && window.location && window.location.origin)
        ? [window.location.origin]
        : [];

function rewriteStr(str) {
	if (typeof str !== 'string' || !str) {
		return str;
	}
	for (let i = 0; i < PROD_DOMAINS.length; i++) {
		if (str.indexOf(PROD_DOMAINS[i]) === 0) {
			return str.substring(PROD_DOMAINS[i].length);
		}
	}
	// JSON 字符串内部(如消息 content 的 url/thumbUrl)递归改写
	if (str.charAt(0) === '{' || str.charAt(0) === '[') {
		try {
			const obj = JSON.parse(str);
			if (obj && typeof obj === 'object') {
				return JSON.stringify(rewriteOriginUrls(obj));
			}
		} catch (e) { /* 非JSON文本，原样返回 */ }
	}
	return str;
}

export function rewriteOriginUrls(data) {
	if (typeof data === 'string') {
		return rewriteStr(data);
	}
	if (Array.isArray(data)) {
		for (let i = 0; i < data.length; i++) {
			data[i] = rewriteOriginUrls(data[i]);
		}
		return data;
	}
	if (data && typeof data === 'object') {
		for (const k in data) {
			if (Object.prototype.hasOwnProperty.call(data, k)) {
				data[k] = rewriteOriginUrls(data[k]);
			}
		}
	}
	return data;
}
